import {Link} from "react-router-dom";
import {Empty} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon} from "~/components";
import style from "../style/Keyword.module.scss";

const cn = className.bind(style);

/** Panel CTA khi dự án chưa kết nối GSC — dùng chung cho các tab cần dữ liệu Search Console. */
function ConnectGscCta({projectId, message = 'Tính năng này dùng dữ liệu tìm kiếm thật từ Google Search Console — dự án này chưa kết nối.'}) {
	return (
		<div className={cn('ctaPanel')}>
			<Empty description={message} />
			<div style={{marginTop: 16}}>
				<Link to={`/projects/${projectId}/gsc`}>
					<Button primary leftIcon={<FontAwesomeIcon icon="fa-light fa-plug" />}>Kết nối Search Console</Button>
				</Link>
			</div>
		</div>
	);
}

export default ConnectGscCta;
